module.exports = {"511504002":"南岸街道","511504003":"赵场街道","511504100":"柏溪镇","511504101":"南广镇","511504102":"喜捷镇","511504103":"观音镇","511504104":"横江镇","511504105":"柳嘉镇","511504106":"泥溪镇","511504107":"蕨溪镇","511504108":"商州镇","511504109":"高场镇","511504110":"安边镇","511504111":"双龙镇","511504112":"李场镇","511504113":"合什镇","511504114":"古罗镇","511504115":"复龙镇","511504116":"普安镇","511504117":"古柏镇","511504118":"泥南镇","511504201":"隆兴乡","511504202":"龙池乡","511504203":"凤仪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511504.json
// module id = 2357
// module chunks = 0